import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { isEmpty } from 'lodash';
import Loader from '../Loader/Loader';
import SupportCategory from './SupportCategory';
import PageHeader from '../PageHeader/PageHeader';
import './Support.scss';

class Support extends React.PureComponent {
  componentWillMount() {
    const { categories, categoriesPending } = this.props;

    window.scrollTo(0, 0);

    if (isEmpty(categories) && !categoriesPending) {
      this.props.fetchCategories();
    }
  }

  render() {
    const { categories, categoriesPending } = this.props;

    return (
      <main>
        <PageHeader
          title="Support centre"
        />
        <div className="container support">
          <h4 className="support-sub-title">Welcome to the Skinny support centre, click one of the tiles below
            for helpful articles about Skinny Fixed-line Broadband, if you don&apos;t
            find the answer to your question, send us a
            <Link
              className="support-contact-link"
              to="/contact-us"
            >
              message
            </Link>
            or contact our Care team<a
              className="care-team-link"
              href="https://www.skinny.co.nz/contact-us/#:~:text=Our%20number%20is%200800%204,%3A00am%20-%205%3A30pm."
            >
              here
            </a>.
          </h4>
          {categoriesPending && <Loader height={'75px'} />}
          {categories && categories.map(category => (
            <SupportCategory
              key={category.id}
              id={category.id}
              title={category.title}
              description={category.description}
              uri={category.uri}
            />
          ))}
          <Link to={'/'} className={'btn btn-default support-btn support-main-button'}>BACK</Link>
        </div>
      </main>
    );
  }
}

Support.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  categoriesPending: PropTypes.bool,
  fetchCategories: PropTypes.func
};

export default Support;



/** WEBPACK FOOTER **
 ** ./src/components/Support/Support.js
 **/